// InventarioXL utils - Sprint 44 Fase 3 Vista 5.
// Helpers especificos de inventario y kardex. Reusa fmtMoney/fmtNumber
// de utils/money.js para no duplicar.
import { API_BASE } from '../../api/apiClient';

export function mediaUrl(rel) {
  if (!rel) return null;
  if (/^https?:\/\//.test(rel)) return rel;
  const base = API_BASE.replace(/\/api\/?$/, '');
  return base + rel;
}

const FMT2 = new Intl.NumberFormat('es-CO', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const FMT0 = new Intl.NumberFormat('es-CO', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function fmtNum(value, dec) {
  if (value === null || value === undefined || value === '') return '\u2014';
  const n = Number(value);
  if (Number.isNaN(n)) return '\u2014';
  return dec === 0 ? FMT0.format(n) : FMT2.format(n);
}

export function fmtFecha(iso) {
  if (!iso) return '\u2014';
  try { return new Date(iso).toLocaleString('es-CO'); }
  catch (_) { return String(iso); }
}

export const TIPO_VARIANT = {
  entrada: 'success',
  salida:  'danger',
  ajuste:  'warning',
};

export const TIPO_LABEL = {
  entrada: 'Entrada',
  salida:  'Salida',
  ajuste:  'Ajuste',
};
